document.addEventListener("DOMContentLoaded", function () {

    let className = "";

    if (/android/i.test(navigator.userAgent)) {
        className = "android";
    } else if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        className = "ios";
    } else {
        className = "desktop";
    }

    document.body.classList.add(className);
    // Select all expandable sections
    const expandableSections = document.querySelectorAll(".expandable-section");


    const expandableSectionContainer = document.querySelectorAll(".expanded-find-your");

    expandableSections.forEach(section => {
        section.addEventListener("click", function () {
            // Remove the "expanded" class from all sections
            expandableSections.forEach(item => item.classList.remove("expanded"));

            // Add the "expanded" class to the clicked section
            this.classList.add("expanded");
            if (expandableSectionContainer) {
              // Remove existing classes
              expandableSectionContainer[0].classList.remove("halfwaves", "fullwaves");

              // Check the data-bg attribute and apply the correct class
              const bgType = this.getAttribute("data-bg");

              if (bgType === "full") {
                  expandableSectionContainer[0].classList.add("fullwaves");
              } else if (bgType === "half") {
                  expandableSectionContainer[0].classList.add("halfwaves");
              }
          }
        });
    });

    // Monitor for external star rating app
    monitorStarRating();
});

// Function to monitor and update star rating from external app
function monitorStarRating() {
    const starContainer = document.querySelector('#product-form .expanded-stars');
    if (!starContainer) return;

    // Add click event listener to scroll to reviews
    starContainer.addEventListener('click', function(e) {
        e.preventDefault(); // Prevent the default anchor behavior
        
        const reviewElement = document.querySelector('.junip-product-review');
        if (reviewElement) {
            reviewElement.scrollIntoView({ 
                behavior: 'smooth', 
                block: 'start' 
            });
        }
    });

    // Function to update star display
    function updateStarDisplay(rating) {
        const starRating = starContainer.querySelector('#product-form .star-rating');
        const starRatingTextSpan = starContainer.querySelector('#product-form .star-rating-text');

        if (!starRating || !starRatingTextSpan) return;

        // Get the star image URL from an existing star
        const existingStar = starRating.querySelector('.star');
        const starImageUrl = existingStar ? existingStar.src : '';

        // Clear existing stars
        starRating.innerHTML = '';

        // Calculate full and half stars
        const fullStars = Math.floor(rating);
        const hasHalfStar = rating % 1 !== 0;

        // Create stars
        for (let i = 1; i <= 5; i++) {
            const star = document.createElement('img');
            star.src = starImageUrl;
            star.alt = 'star';
            star.className = 'star';
            star.width = 20;
            star.height = 20;

            if (i <= fullStars) {
                star.classList.add('full');
            } else if (i === fullStars + 1 && hasHalfStar) {
                star.classList.add('half');
            } else {
                star.classList.add('empty');
            }

            starRating.appendChild(star);
        }

        // Update rating text span if it exists
        if (starRatingTextSpan) {
            starRatingTextSpan.textContent = rating.toFixed(1);
        }

    }

    // Function to check for the external rating
    function checkForExternalRating() {
        const externalRatingElement = document.querySelector('.junip-product-review-average');
        
        if (externalRatingElement) {
            const ratingText = externalRatingElement.textContent.trim();
            const rating = parseFloat(ratingText);
            if (!isNaN(rating) && rating >= 0 && rating <= 5) {
                updateStarDisplay(rating);
                return true; // Successfully found and updated
            }
        }
        return false; // Not found or invalid
    }

    // Initial check
    if (checkForExternalRating()) {
        return; // Already found, no need to monitor
    }

    // Set up monitoring with MutationObserver
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        // Check if the added node or its children contain the rating
                        const ratingElement = node.querySelector ? 
                            node.querySelector('.junip-product-review-average') : 
                            (node.classList && node.classList.contains('junip-product-review-average') ? node : null);
                        
                        if (ratingElement) {
                            const ratingText = ratingElement.textContent.trim();
                            const rating = parseFloat(ratingText);
                            
                            if (!isNaN(rating) && rating >= 0 && rating <= 5) {
                                updateStarDisplay(rating);
                                observer.disconnect(); // Stop monitoring once found
                            }
                        }
                    }
                });
            }
        });
    });

    // Start observing
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    // Fallback: also check periodically for a limited time
    let checkCount = 0;
    const maxChecks = 20; // Check for 10 seconds (20 * 500ms)
    
    const intervalCheck = setInterval(function() {
        checkCount++;
        
        if (checkForExternalRating()) {
            clearInterval(intervalCheck);
            observer.disconnect();
        } else if (checkCount >= maxChecks) {
            clearInterval(intervalCheck);
            observer.disconnect();
            console.log('External star rating not found after 10 seconds');
        }
    }, 500);
}

var currentSlide = 0;
let slides = document.querySelectorAll('.expanded-circle-item');
let dotsContainer = document.querySelector('.dots-container');
let isMobile = window.innerWidth <= 1100;
let slideInterval;

// Create slide dots
function createDots() {
  dotsContainer.innerHTML = ''; // Clear previous dots
  slides.forEach((_, index) => {
    let dot = document.createElement('span');
    dot.classList.add('s-dot');
    dot.addEventListener('click', () => {
      resetTimer();
      console.log(index);
      showSlide(index);
    });
    dotsContainer.appendChild(dot);
  });
}

// Show Slide
function showSlide(index) {
  if (!isMobile) return;

  if (index >= (slides.length - 1)) currentSlide = 0;
  if (index < 0) currentSlide = slides.length - 1;
  else currentSlide = index;

  slides.forEach((slide, i) => slide.classList.toggle('active', i === currentSlide));
  document.querySelectorAll('.s-dot').forEach((dot, i) => dot.classList.toggle('active', i === currentSlide));
}

// Start Auto Slide
function startAutoSlide() {
  slideInterval = setInterval(() => {
    if (isMobile) changeSlide(1);
  }, 5000);
}

// Reset Timer
function resetTimer() {
  clearInterval(slideInterval);
  startAutoSlide();
}

// Change Slide
function changeSlide(direction) {
  currentSlide = currentSlide + direction;
  if (currentSlide >= (slides.length - 1)) currentSlide = 0;
  if (currentSlide < 0) currentSlide = slides.length - 1;


  showSlide(currentSlide);
  resetTimer();
}

// Update Layout Based on Screen Size
function updateLayout() {
  isMobile = window.innerWidth <= 1100;
  if (isMobile) {
    createDots();
    showSlide(0);
    startAutoSlide();
  } else {
    clearInterval(slideInterval);
    slides.forEach(slide => slide.classList.add('active'));
  }
}

// Listen for Resize
//window.addEventListener('resize', updateLayout);
updateLayout(); // Run on load


document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".marquee-item");
  let index = 0;

  function highlightNextItem() {
      // Remove the class from all items
      items.forEach(item => item.classList.remove("highlighted"));

      // Add the class to the current item
      items[index].classList.add("highlighted");

      // Move to the next index
      index = (index + 1) % items.length;
  }

  // Start the interval
  highlightNextItem(); // Initial highlight
  setInterval(highlightNextItem, 3000);
});

